import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircularProgress from "@mui/material/CircularProgress";
import { Header } from "../../components/landing/header";
import { Footer } from "../../components/landing/footer";
import { verifyPaymentSession } from "../../services/subscription";
import "./PaymentSuccess.css";

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  const [loading, setLoading] = useState(true);
  const [paymentVerified, setPaymentVerified] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const verifyPayment = async () => {
      if (!sessionId) {
        setLoading(false);
        setPaymentVerified(true); // Show success even without session_id (user may have navigated directly)
        return;
      }

      try {
        const response = await verifyPaymentSession(sessionId);
        if (response?.status === "complete" || response?.status === "paid") {
          setPaymentVerified(true);
        } else {
          setPaymentVerified(true); // Still show success, webhook will handle the actual update
        }
      } catch (err) {
        console.error("Error verifying payment:", err);
        // Still show success - the webhook will handle the actual subscription update
        setPaymentVerified(true);
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();
  }, [sessionId]);

  const handleGoToCoupons = () => {
    navigate("/coupons/profile");
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <>
      <Header />
      <section className="payment-section">
        <div className="container">
          <div className="payment-card">
            {loading ? (
              <div className="payment-loading">
                <CircularProgress size={48} style={{ color: "#0032a1" }} />
                <p className="payment-loading-text">Verifying your payment...</p>
              </div>
            ) : paymentVerified ? (
              <>
                <div className="payment-icon-container payment-icon-success">
                  <CheckCircleIcon />
                </div>
                <h2 className="payment-title">Payment Successful!</h2>
                <p className="payment-message">
                  Thank you for your purchase! Your subscription has been activated
                  and you now have unlimited access to all coupon creation features.
                </p>
                <div className="payment-details">
                  <div className="payment-detail-row">
                    <span className="payment-detail-label">Amount Paid</span>
                    <span className="payment-detail-value">$65.00</span>
                  </div>
                  <div className="payment-detail-row">
                    <span className="payment-detail-label">Plan</span>
                    <span className="payment-detail-value">One-Time Access</span>
                  </div>
                  <div className="payment-detail-row">
                    <span className="payment-detail-label">Status</span>
                    <span className="payment-detail-value payment-status-success">Active</span>
                  </div>
                </div>
                <div className="payment-btn-container">
                  <button className="theme-btn payment-btn-primary" onClick={handleGoToCoupons}>
                    Start Creating Coupons
                  </button>
                  <button className="theme-btn white-btn payment-btn-secondary" onClick={handleGoHome}>
                    Back to Home
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="payment-icon-container payment-icon-warning">
                  <CheckCircleIcon />
                </div>
                <h2 className="payment-title">Payment Processing</h2>
                <p className="payment-message">
                  {error || "Your payment is being processed. Please check back in a few minutes."}
                </p>
                <div className="payment-btn-container">
                  <button className="theme-btn payment-btn-primary" onClick={handleGoHome}>
                    Go to Home
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
